import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { focusPageTop } from '../utils/focusPageTop';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    focusPageTop();
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
